/* global s */
'use strict';

class ProductTariffPlan {
	constructor(options) {
		console.log('ProductTariffPlan::constructor(%o)', options);

		const destination_selector_minutes = document.getElementById('destination_selector_minutes');
		const destination_selector_unlimited = document.getElementById('destination_selector_unlimited');
		const destination_selector_world = document.getElementById('destination_selector_world');
		const destination_selector_credit = document.getElementById('destination_selector_credit');
		const free_destinations_list_trigger = document.getElementById('free_destinations_list_trigger');

		if (free_destinations_list_trigger) {
			free_destinations_list_trigger.addEventListener('click', (e) => {
				e.preventDefault();
				s.common.scrollToAnchor('#free-destinations-list');
			});
		}

		this.bindDestinationEvents(destination_selector_minutes);
		this.bindDestinationEvents(destination_selector_unlimited);
		this.bindDestinationEvents(destination_selector_world);
		this.bindDestinationEvents(destination_selector_credit);
	}

	bindDestinationEvents(selector_element) {
		if (selector_element) {
			selector_element.addEventListener('change', (e) => {
				try {
					const el = e.target;
					const buy_link = el.closest('.new_card').querySelector('.bottom a');
					const url = new URL(buy_link.href);
					const url_query = new URLSearchParams(url.search);
					url_query.delete('destination');
					if (el.value !== '') {
						url_query.append('destination', el.value);
					}
					url.search = `?${url_query.toString()}`;
					buy_link.href = url.href;
				} catch (e) {
					console.warn(e);
				}
			});
			selector_element.dispatchEvent(new Event('change', {cancelable: true, bubbles: true}));
		}
	}
}
